/**
 * Asks the engine to (re)open the practice yard.
 *
 * The yard is a whole view that owns `root`, so only `bootstrap.ts` — which
 * holds the view teardown — can swap it in. Anything else (the Settings
 * "Replay the practice yard" button) just raises this flag, the same way the
 * settlement already signals arena and location swaps through their stores.
 */
import { createStore } from '../../core/state/store';

export interface TutorialYardState {
  requested: boolean;
}

export const tutorialYardStore = createStore<TutorialYardState>({ requested: false });

export function requestTutorialYard(): void {
  tutorialYardStore.set({ requested: true });
}

/** Called by the engine once it has acted on the request. */
export function clearTutorialYardRequest(): void {
  if (tutorialYardStore.get().requested) tutorialYardStore.set({ requested: false });
}
